import React, { useEffect, useState } from "react"
import {
	Modal, Button, Form, Select, Checkbox
}from "antd"
import {
    useDispatch,
	useSelector
}from "react-redux"
import i18n from "./localization"
import SelectExecutPosition from "../../nsi/ReResponsiblesExecutPosition/SelectExecutPosition"
import "antd/lib/modal/style/index.css"
import "./style.css"
import { useDebounce } from "use-lodash-debounce"
import {
	managementActions
}from "../store/actions"
import { CustomSelect } from "../../../components/CustomSelect"
import Notifications from "../../../helpers/Notifications"
import history from "../../../helpers/history"

const ModalReassignSubunitUser = (props) => {
	const [form] = Form.useForm()
	const { setVisible, visible, userId } = props
	const isRu = useSelector((state) => state.globalReducer.isRu)
    const {subunitOrgList, orgSubunitError, subunitOrgUserChanged, orgSubUnitLoading} = useSelector((state) => state.managementReducer)
    const [subunitSearchOrgs, setSubunitSearchOrgs] = useState(null)
    const [allowAdmin, setAllowAdmin] = useState(false)
    const searchValue = useDebounce(subunitSearchOrgs, 500)
    const dispatch = useDispatch()
	const onFinish = (values) => {
        dispatch(managementActions.reassignOrgUser({
			userId : userId,
			reOrgId : values.ReOrgId,
			externalAdminRights : values.ExternalAdminRights
		}))
	}

    useEffect(() => {
        if(subunitOrgUserChanged){
			Notifications.successNotice("Пользователь успешно переназначен в обособленное подразделение", "", 5)
            dispatch(managementActions.clearSubunitOrgs())
            setVisible(false)
			history.replace("/orgManagement")
        }
    },[subunitOrgUserChanged])

    useEffect(() => {
        dispatch(managementActions.getSubunitOrgsList({search : searchValue}))
    }, [searchValue])

	return (
		<Modal
			className="modal-position-choice"
			footer={ [] }
			visible={ visible }
			width={ 700 }
			onCancel={ () => {
                setVisible(false)
                dispatch(managementActions.clearSubunitOrgs())
            } }
		>
			<Form
				form={ form }
				labelAlign="left"
				layout="vertical"
				onFinish={ onFinish }
			>
				<Form.Item
				className="position-register-by-admin"
				label={ i18n.orgName[isRu] }
				name="ReOrgId"
				rules={ [{ message  : i18n.isRequired[isRu],
						required : true }] }
				>
						<CustomSelect
                            mode="single"
                            filterOption={ false }
                            notFoundContent={ null }
							allowClear
							showSearch
							placeholder={ i18n.orgNamePlaceHolder[isRu] }
							style={ {
								width: "100%"
							} }
							onSearch={ (value) => setSubunitSearchOrgs(value) }
                            onChange = { (value, obj) => {
                                setAllowAdmin(obj.hasNoAdmin)
                            } }
						>
							{ subunitOrgList?.map((value) => {
								return (
									<Select.Option
										hasNoAdmin = { value.hasNoExternalAdmin }
										key={ value.id }
										style={ {
											width: "100%"
										} }
										title={ value.orgName[isRu] ? value.orgName[isRu] : value.orgName[!isRu] }
										value={ value.id }
									>
									    { value.orgName[isRu] ? value.orgName[isRu] : value.orgName[!isRu] }
									</Select.Option>
										)}) }
						</CustomSelect>
				</Form.Item>
                { allowAdmin? 
                (
                    <>
                        <Form.Item
                        name={ "ExternalAdminRights" }
                        valuePropName="checked">
							<Checkbox>
								{ i18n.externalAdminRights[isRu] }
							</Checkbox>
                        </Form.Item>
                    </>
                ): null}
				<Button
					htmlType="submit"
					loading={ orgSubUnitLoading }
					type="primary"
				>
					{ i18n.reassignSubmit[isRu] }
				</Button>
			</Form>
		</Modal>
	)
}

export default ModalReassignSubunitUser
